import {
  downloadUrl,
  type DownloadResult,
  type DownloadUrlOptions
} from '@/utils/download';
import type { DispatchPayload } from './tim-bridge';

type DownloadPayload = Extract<DispatchPayload, { type: 'DOWNLOAD' }>;

function toDownloadUrlOptions(payload: DownloadPayload): DownloadUrlOptions {
  return {
    requestId: payload.requestId,
    url: payload.url,
    fileName: payload.fileName,
    mimeType: payload.mimeType,
    mediaKind: payload.mediaKind,
    saveToPhotos: payload.saveToPhotos
  };
}

export async function handleDownload(
  payload: DownloadPayload
): Promise<DownloadResult> {
  return downloadUrl(toDownloadUrlOptions(payload));
}
